import {
  CLEAR_UPDATE_CARD_DETAILS,
  VERIFY_CARD_SUCCESS,
} from "./ActionConstant";
import { VERIFY_CARD_FAILURE } from "./ActionConstant";
import { VERIFY_CARD_START } from "./ActionConstant";
import {
  FETCH_CARD_DETAILS_START,
  FETCH_CARD_DETAILS_SUCCESS,
  FETCH_CARD_DETAILS_FAILURE,
  DELETE_CARD_START,
  DELETE_CARD_SUCCESS,
  DELETE_CARD_FAILURE,
  SELECT_DEFAULT_CARD_START,
  SELECT_DEFAULT_CARD_SUCCESS,
  SELECT_DEFAULT_CARD_FAILURE,
  ADD_CARD_START,
  ADD_CARD_SUCCESS,
  ADD_CARD_FAILURE,
  GET_CARD_START,
  GET_CARD_SUCCESS,
  GET_CARD_FAILURE,
  UPDATE_CARD_START,
  UPDATE_CARD_SUCCESS,
  UPDATE_CARD_FAILURE,
  DOCUMENT_UPLOAD_FOR_CARD_VERIFICATION_START,
  DOCUMENT_UPLOAD_FOR_CARD_VERIFICATION_RESET
} from "./ActionConstant";

// Get Card Details actions.

export function fetchCardDetailsStart() {
  return {
    type: FETCH_CARD_DETAILS_START,
  };
}

export function fetchCardDetailsSuccess(data) {
  return {
    type: FETCH_CARD_DETAILS_SUCCESS,
    data,
  };
}

export function fetchCardDetailsFailure(error) {
  return {
    type: FETCH_CARD_DETAILS_FAILURE,
    error,
  };
}

export function getCardStart(data) {
  return {
    type: GET_CARD_START,
    data,
  };
}

export function getCardSuccess(data) {
  return {
    type: GET_CARD_SUCCESS,
    data,
  };
}

export function getCardFailure(error) {
  return {
    type: GET_CARD_FAILURE,
    error,
  };
}

//  Delete card actions.

export function deleteCardStart(data) {
  return {
    type: DELETE_CARD_START,
    data,
  };
}

export function deleteCardSuccess(data) {
  return {
    type: DELETE_CARD_SUCCESS,
    data,
  };
}

export function deleteCardFailure(error) {
  return {
    type: DELETE_CARD_FAILURE,
    error,
  };
}

// Make default card actions.

export function selectDefaultCardStart(data) {
  return {
    type: SELECT_DEFAULT_CARD_START,
    data,
  };
}

export function selectDefaultCardSuccess(data) {
  return {
    type: SELECT_DEFAULT_CARD_SUCCESS,
    data,
  };
}

// add card actions

export function selectDefaultCardFailure(error) {
  return {
    type: SELECT_DEFAULT_CARD_FAILURE,
    error,
  };
}

export function addCardStart(data) {
  return {
    type: ADD_CARD_START,
    data,
  };
}

export function addCardSuccess(data) {
  return {
    type: ADD_CARD_SUCCESS,
    data,
  };
}

export function addCardFailure(error) {
  return {
    type: ADD_CARD_FAILURE,
    error,
  };
}

// update card actions

export function updateCardStart(data) {
  return {
    type: UPDATE_CARD_START,
    data,
  };
}

export function updateCardSuccess(data) {
  return {
    type: UPDATE_CARD_FAILURE,
    data,
  };
}

export function updateCardFailure(error) {
  return {
    type: UPDATE_CARD_FAILURE,
    error,
  };
}

//verify card

export function verifyCardStart(data) {
  return {
    type: VERIFY_CARD_START,
    data,
  };
}

export function verifyCardSuccess(data) {
  return {
    type: VERIFY_CARD_SUCCESS,
    data,
  };
}

export function verifyCardFailure(error) {
  return {
    type: VERIFY_CARD_FAILURE,
    error,
  };
}

// clear update card details

export function clearUpdateCardDetails() {
  return {
    type: CLEAR_UPDATE_CARD_DETAILS,
  };
}

export function startCardVerificationDocumentUpload(data) {
  return {
    type: DOCUMENT_UPLOAD_FOR_CARD_VERIFICATION_START,
    data
  };
}

export function resetCardVerificationDocumentUpload() {
  return {
    type: DOCUMENT_UPLOAD_FOR_CARD_VERIFICATION_RESET,
  };
}
